import React from 'react';

/** Gray band divider that titles a section on a detail page's left card. */
export const SectionBand: React.FC<{ children: string }> = ({ children }) => (
  <div className="bg-gray-50 px-5 py-2.5 border-y border-gray-100">
    <span className="text-[13px] text-gray-500">{children}</span>
  </div>
);

/** Label + value pair inside a detail page section. */
export const Field: React.FC<{
  label: string;
  children: React.ReactNode;
}> = ({ label, children }) => (
  <div className="border-b border-gray-100 pb-3">
    <p className="text-[13px] text-gray-500 mb-1">{label}</p>
    <div className="text-[14px] text-gray-900">{children}</div>
  </div>
);
